import { isEmpty } from 'lodash';
import { Dispatch } from 'redux';
import { ApiOneId } from '../http';
import { ApiUser } from '../http/api-user';
import { userActions } from '../slices/user-slice';

const {
  setUserRequestStart,
  setUserRequestSuccess,
  setUserRequestFailure,
  setUserRequestDefault,

  setUserListRequest,
  setUserListSuccess,
  setUserListFailure,
  setUserListDefault,

  setUserOneRequest,
  setUserOneSuccess,
  setUserOneFailure,
  setUserOneDefault,
} = userActions;

//List
export const getUsers = (params: Record<string, any>) => async (dispatch: Dispatch<any>) => {
  dispatch(setUserListRequest());
  try {
    const data = await ApiUser.fetchAll(params);
    dispatch(setUserListSuccess(data));
  } catch ({ message }) {
    dispatch(setUserListFailure({ message }));
  }
};
export const clearUsers = () => async (dispatch: Dispatch<any>) => {
  dispatch(setUserListDefault());
};

//One
export const getUser = (id: string | number) => async (dispatch: Dispatch<any>) => {
  dispatch(setUserOneRequest());
  try {
    const data = await ApiUser.fetchOne(id);
    dispatch(setUserOneSuccess(data));
  } catch ({ message }) {
    dispatch(setUserOneFailure({ message }));
  }
};
export const getUserByPin = (pin: string) => async (dispatch: Dispatch<any>) => {
  dispatch(setUserOneRequest());
  try {
    const data = await ApiOneId.fetchUserByPin(pin);
    if (isEmpty(data)) {
      dispatch(setUserOneFailure({ message: 'error.notFound' }));
    } else {
      dispatch(setUserOneSuccess(data));
    }
  } catch ({ message }) {
    dispatch(setUserOneFailure({ message }));
  }
};
export const clearUser = () => async (dispatch: Dispatch<any>) => {
  dispatch(setUserOneDefault());
};

//Create
export const createUser = (data: Record<string, any>) => async (dispatch: Dispatch<any>) => {
  dispatch(setUserRequestStart());
  return new Promise((resolve, reject) => {
    ApiUser.createOne(data)
      .then((res) => {
        dispatch(setUserRequestSuccess());
        resolve(res);
      })
      .catch((res) => {
        dispatch(setUserRequestFailure({ message: res?.message }));
        reject(res);
      });
  });
};

//Edit
export const editUser =
  (id: string | number, data: Record<string, any>) => async (dispatch: Dispatch<any>) => {
    dispatch(setUserRequestStart());
    return new Promise((resolve, reject) => {
      delete data.passportPhoto;
      ApiUser.updateOne(id, data)
        .then((res) => {
          dispatch(setUserRequestSuccess());
          resolve(res);
        })
        .catch((res) => {
          dispatch(setUserRequestFailure({ message: res?.message }));
          reject(res);
        });
    });
  };

//Clear request
export const clearUserRequest = () => async (dispatch: Dispatch<any>) => {
  dispatch(setUserRequestDefault());
};
